import styled from 'styled-components';

export const Text404 = styled.div`
margin: 0 auto;
color: orange;
`;

export const Text = styled.p`
margin: 0 auto;
color: orange
`;